import { defineStore } from 'pinia'
import { SearchItem } from '@/types/SyouninGroup'
import OptionConst from '@/const/Option'

export const useSyouninGroupStore = defineStore('SyouninGroup', {
  state: () => {
    return {
      item:<SearchItem> {
        group_name: null,
      },
    }
  },
  actions: {
    // 検索条件のセット
    setItem(searchItem: SearchItem) {
      this.item = searchItem
    },
    // 検索条件のクリア
    clear() {
      this.item = {
        group_name: null,
      };
    },

  },
  getters: {
    searchItem(): SearchItem {
      return this.item
    },
  }
})